import { render, staticRenderFns } from "./damagesTypes.pug?vue&type=template&id=06d5cf28&lang=pug&"
import script from "./damagesTypes.js?vue&type=script&lang=js&"
export * from "./damagesTypes.js?vue&type=script&lang=js&"
import style0 from "./damageTypes.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d5cf28')) {
      api.createRecord('06d5cf28', component.options)
    } else {
      api.reload('06d5cf28', component.options)
    }
    module.hot.accept("./damagesTypes.pug?vue&type=template&id=06d5cf28&lang=pug&", function () {
      api.rerender('06d5cf28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagesTypes/index.vue"
export default component.exports